import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfigWrapper} from '../../../dynamic-field/field-config-wrapper';

@Component({
    selector: 'mydocma-form-field-container',
    templateUrl: './field-container.component.html',
    styleUrls: ['./field-container.component.scss']
})
export class FieldContainerComponent {

    @Input()
    public fieldWrapper: FieldConfigWrapper<any>;

    @Input()
    public formGroup: UntypedFormGroup;

    public collapsed = true;

    constructor(private readonly changeDetectorRef: ChangeDetectorRef) {
    }

    public onResize(event) {
        const collapsed = event.contentRect.width <= 500;
        if (collapsed !== this.collapsed) {
            this.collapsed = collapsed;
            this.changeDetectorRef.detectChanges();
        }
    }
}
